function formatCurrency(value, options) {
  const {
    locale = "it-IT",
    minimumFractionDigits = 2,
    maximumFractionDigits = 2
  } = options ?? {};
  return value.toLocaleString(locale, {
    minimumFractionDigits,
    maximumFractionDigits
  });
}
export {
  formatCurrency
};
//# sourceMappingURL=formatting.es.js.map
